import { render } from "./ReadPriceList.vue?vue&type=template&id=5bad32f0"
import script from "./ReadPriceList.vue?vue&type=script&lang=js"
export * from "./ReadPriceList.vue?vue&type=script&lang=js"

import "./ReadPriceList.vue?vue&type=style&index=0&id=5bad32f0&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__